export default "__VITE_ASSET__6$Nb$3CH__"